import './SignaturePage.scss';
import { CustomBottomBar } from '@components';
import { Button, Container, Modal, Spacing, Typography } from '@design-system';
import SignatureCanvas from 'react-signature-canvas';
import { useSignaturePageVM } from './useSignaturePageVM';
import { RiArrowGoBackLine } from 'react-icons/ri';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { IoMdClose } from 'react-icons/io';

export const SignaturePage: React.FC = () => {
    const {
        signatureCanvasRef,
        handleClearSignature,
        isEmpty,
        setIsEmpty,
        showConfirmationModal,
        setShowConfirmationModal,
        handleConfirmSave
    } = useSignaturePageVM();

    return (
        <>
            <Container className="signature-page">
                <Typography intrinsic="h2" className="signature-title">
                    Maintenant, veuillez créer et enregistrer votre signature.
                </Typography>
                <Container bordered="grey" center column padding="medium" className="signature-container">
                    <Typography intrinsic="p" color="marine" className="mt-small-spacing">
                        Dessinez votre signature sur l'écran à l'aide de votre doigt ou d'un stylet sur l'espace ci-dessous.
                    </Typography>
                    <Typography intrinsic="p" variant="secondary" color="grey" className="mt-small-spacing">
                        Votre signature sera utilisée pour valider des documents internes. Prenez un moment pour dessiner une signature
                        claire et précise.
                    </Typography>

                    <Container padding="none" className="signature-grow">
                        <SignatureCanvas
                            throttle={24}
                            velocityFilterWeight={1}
                            penColor="black"
                            canvasProps={{
                                className: 'sigCanvas'
                            }}
                            onEnd={() => setIsEmpty(false)}
                            ref={signatureCanvasRef}
                        />
                        <Spacing />
                        <div className="buttons">
                            <Button
                                icon={<RiArrowGoBackLine />}
                                iconSize={25}
                                onClick={handleClearSignature}
                                iconColor="green"
                                variant="secondary"
                                color="green"
                                className="refresh-signature-button"
                            >
                                <></>
                            </Button>
                        </div>
                    </Container>
                </Container>
            </Container>
            <CustomBottomBar>
                <Button
                    onClick={() => setShowConfirmationModal(true)}
                    color="marine"
                    size="fullwidth"
                    icon={<MdKeyboardArrowRight />}
                    iconPosition="forced-right"
                    iconColor="white"
                    iconSize={25}
                    disabled={isEmpty}
                >
                    <Typography intrinsic="h4">Enregistrer</Typography>
                </Button>
            </CustomBottomBar>

            <Modal
                title="Confirmation"
                open={showConfirmationModal}
                setClose={() => setShowConfirmationModal(false)}
                className="signature-confirmation-modal"
                footer={
                    <div className="modal-footer">
                        <Button
                            color="grey"
                            variant="tertiary"
                            onClick={() => setShowConfirmationModal(false)}
                            icon={<IoMdClose />}
                            iconPosition="right"
                            iconSize={20}
                        >
                            <Typography intrinsic="h4">Annuler</Typography>
                        </Button>
                        <Button color="green" size="small" variant="secondary" onClick={handleConfirmSave}>
                            <Typography intrinsic="h4">Valider</Typography>
                        </Button>
                    </div>
                }
            >
                <Container padding="medium" className="modal-text-container">
                    <Typography intrinsic="p" variant="secondary">
                        En appuyant sur "valider", vous acceptez que votre signature soit apposée sur tous les documents la nécessitant.
                    </Typography>
                </Container>
            </Modal>
        </>
    );
};
